import { Case } from '@/api/apis/case';
import { CaseResult } from './CaseResult';
import { CaseIdProvider } from '@/contexts';

type ResultsListProps = {
  taskId: string;
  caseList: Case[];
  chainNumber: number;
};

export const ResultsList = ({ taskId, caseList, chainNumber }: ResultsListProps) => {
  const [initialCase, ...otherCases] = caseList;

  return (
    <div className="flex gap-8 items-start">
      <CaseIdProvider caseId={initialCase.caseId}>
        <CaseResult taskId={taskId} caseData={initialCase} chainNumber={chainNumber} isInitialCase />
      </CaseIdProvider>
      <div className="flex gap-3 pr-4 items-start">
        {otherCases.map((caseData) => (
          <CaseIdProvider key={caseData.caseId} caseId={caseData.caseId}>
            <CaseResult key={caseData.caseId} taskId={taskId} caseData={caseData} chainNumber={chainNumber} />
          </CaseIdProvider>
        ))}
      </div>
    </div>
  );
};
